module.exports = __webpack_public_path__ + "img/guide5.d20c1960.png";